import { render } from "./ToggleShowBrand.vue?vue&type=template&id=39f36c0c&scoped=true"
import script from "./ToggleShowBrand.vue?vue&type=script&lang=js"
export * from "./ToggleShowBrand.vue?vue&type=script&lang=js"

import "./ToggleShowBrand.vue?vue&type=style&index=0&id=39f36c0c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f36c0c"]])

export default __exports__